import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { Fragment } from 'react/jsx-runtime';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { useUserInfoList } from '@/scripts/hooks/useUserInfoList';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupSendMsgMemberContentProps {
  message: Msg;
}

export const MsgGroupSendMsgMemberContent = memo(function MsgGroupSendMsgMemberContent({
  message,
}: MsgGroupSendMsgMemberContentProps) {
  const { operator_user_id, target_user_ids } = message.payload;

  const { user: operatorUser } = useUserInfo(operator_user_id);
  const { users: members } = useUserInfoList(target_user_ids);

  return (
    <MyTrans
      i18nKey="chat.groupMessageSendMsgMemberText"
      components={{
        actionUser: <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />,
        action: <Text as="span" color="fg.muted" />,
        members: (
          <Text as="span" color="fg.muted">
            {members?.map((user, index) => (
              <Fragment key={user.user_id}>
                {index > 0 && ', '}
                <MsgUserText userName={user.name} userId={user.user_id} />
              </Fragment>
            ))}
          </Text>
        ),
      }}
    ></MyTrans>
  );
});
